let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9sK10")).then(() => parcelRequire('6asVI'));